function applyTransitionDelay() {
  const megaMenuItems = document.querySelectorAll(".mega__menu-item");
  const megaChildItems = document.querySelectorAll(".mega__child > li");

  megaChildItems.forEach((item, index) => {
    const delay = (index / megaChildItems.length) * 0.5;
    item.style.transitionDelay = `${delay}s`;
  });

  megaMenuItems.forEach((item, index) => {
    const delay = 0.5 + (index / megaMenuItems.length) * 0.5;
    item.style.transitionDelay = `${delay}s`;
  });
}

function removeTransitionDelay() {
  const megaMenuItems = document.querySelectorAll(".mega__menu-item");
  const megaChildItems = document.querySelectorAll(".mega__child > li");

  megaMenuItems.forEach((item) => (item.style.transitionDelay = ""));
  megaChildItems.forEach((item) => (item.style.transitionDelay = ""));
}


function setupMegaMenu() {
  let isMenuOpen = false;
  let overlay = null;
  document.querySelectorAll(".site__nav-wrapper > li").forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const megaMenu = this.querySelector(".mega__menu");
      if (megaMenu) {
        megaMenu.classList.add("open");
        this.classList.add("menu-open"); // Add class to li
        applyTransitionDelay();
        isMenuOpen = true;
        overlay = document.createElement("div");
        overlay.classList.add("custom-overlay");
        document.body.appendChild(overlay);
        document.addEventListener('wheel', preventScroll, { passive: false });
        document.addEventListener('touchmove', preventScroll, { passive: false });
      }
    });

    item.addEventListener("mouseleave", function () {
      const megaMenu = this.querySelector(".mega__menu");
      if (megaMenu) {
        megaMenu.classList.remove("open");
        this.classList.remove("menu-open"); // Remove class from li
        removeTransitionDelay();
        isMenuOpen = false;
        if (overlay) {
          overlay.remove();
          overlay = null;
        }
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
      }
    });
  });



  

  function preventScroll(e) {
    if (!isMenuOpen) return;

    const megaMenu = e.target.closest(".mega__menu");
    if (megaMenu) {
      const isScrollable = megaMenu.scrollHeight > megaMenu.clientHeight;
      if (isScrollable) {
        const scrollTop = megaMenu.scrollTop;
        const scrollHeight = megaMenu.scrollHeight;
        const clientHeight = megaMenu.clientHeight;
        const wheelDelta = e.deltaY || e.detail || e.wheelDelta;

        if (wheelDelta > 0 && scrollTop + clientHeight >= scrollHeight) {
          e.preventDefault();
          e.stopPropagation();
        } else if (wheelDelta < 0 && scrollTop <= 0) {
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }
    }

    e.preventDefault();
    e.stopPropagation();
  }
}




function initializeMegaMenuSwipers() {
  const swipers = document.querySelectorAll('.mega__items .swiper');
  
  swipers.forEach((swiper) => {
    new Swiper(swiper, {
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: swiper.querySelector('.swiper-pagination'),
        clickable: true,
      }
    });
  });
}



document.addEventListener("DOMContentLoaded", function () {
  setupMegaMenu();
  initializeMegaMenuSwipers();
});




document.addEventListener('DOMContentLoaded', () => {
  const initSearch = wrapper => {
    const selector = wrapper.querySelector('.header-search-selector');
    const searchInput = wrapper.querySelector('.predictive-search-field');
    const popups = wrapper.querySelector('.header-search-popups');
    const button = selector.querySelector('.header-search-selected');
    const dropdown = wrapper.querySelector('.header-search-selector-list');

    const addClass = wrapper.querySelector('.header-search-inner');
 
    const selectedText = button.querySelector('span');
    const items = Array.from(selector.querySelectorAll('li'));
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    const popupMap = {
      'insite': '.new-search',
      'search-in-korea': '.search-korea',
      'bunjang-market': '.bunjang-market',
      'coupang': '.search-coupang'
    };

 


    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    const fetchSearchResults = async (query) => {
      const newSearchPopup = popups.querySelector('.new-search');
      const newSearchInner = newSearchPopup.querySelector('.new-search-inner');
      const searchResultsWrapper = newSearchPopup.querySelector('.search-results-wrapper');
      const searchResultsInner = newSearchPopup.querySelector('.search-results-inner');

      if (!query) {
        newSearchInner.classList.add('visible');
        searchResultsWrapper.classList.remove('visible');
        searchResultsInner.innerHTML = '';
        return;
      }

      try {
        const response = await fetch(`/search/suggest?q=${encodeURIComponent(query)}&section_id=new-search-results&resources[type]=product,collection&resources[limit]=10`);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const renderedResults = doc.querySelector('.shopify-section-search-results').innerHTML;

        newSearchInner.classList.remove('visible');
        searchResultsWrapper.classList.add('visible');
        searchResultsInner.innerHTML = renderedResults;
      } catch (error) {
        newSearchInner.classList.remove('visible');
        searchResultsWrapper.classList.add('visible');
        searchResultsInner.innerHTML = '<div class="no-results"><p>No results found</p></div>';
      }
    };

    const setInitialText = () => {
      const defaultItem = items.find(item => item.dataset.site === button.dataset.selectedSite);
      if (defaultItem) selectedText.textContent = defaultItem.textContent;
      popups.querySelectorAll('[data-site]').forEach(popup => {
        popup.classList.remove('visible');  
      });

      const newSearchPopup = popups.querySelector('.new-search');
      if (newSearchPopup) {
        newSearchPopup.querySelector('.new-search-inner').classList.add('visible');
        newSearchPopup.querySelector('.search-results-wrapper').classList.remove('visible');
        newSearchPopup.querySelector('.search-results-inner').innerHTML = '';
      }
      if (isMobile()) {
        popups.classList.add('visible');
        newSearchPopup.classList.add('visible');
      } else {
        popups.classList.remove('visible');
      }
    };

    const toggleDropdown = e => {
      e.stopPropagation();
      document.querySelectorAll('.header-search-selector-list.active')
        .forEach(other => other !== dropdown && other.classList.remove('active'));
      document.querySelectorAll('.header-search-selected.active')
        .forEach(other => other !== button && other.classList.remove('active'));
      dropdown.classList.toggle('active');
      button.classList.toggle('active');
    };

    const updatePopupVisibility = () => {
      const selectedSite = button.dataset.selectedSite;
      const selectedPopup = popupMap[selectedSite];

      popups.querySelectorAll('[data-site]').forEach(popup => {
        popup.classList.remove('visible');
        
      });

      if (isMobile()) {
        popups.classList.add('visible');
        const activePopup = popups.querySelector(selectedPopup);
        if (activePopup) {
          setTimeout(() => {
            activePopup.classList.add('visible');
            if (selectedSite === 'insite') {
              const newSearchInner = activePopup.querySelector('.new-search-inner');
              const searchResultsWrapper = activePopup.querySelector('.search-results-wrapper');
              const hasQuery = searchInput.value.trim();
              newSearchInner.classList.toggle('visible', !hasQuery);
              searchResultsWrapper.classList.toggle('visible', hasQuery);
            }
          }, 10);
        }
      } else {
        popups.classList.toggle('visible', searchInput === document.activeElement);
        if (searchInput === document.activeElement) {
          const activePopup = popups.querySelector(selectedPopup);
          if (activePopup) {
            setTimeout(() => {
              activePopup.classList.add('visible');
              if (selectedSite === 'insite') {
                const newSearchInner = activePopup.querySelector('.new-search-inner');
                const searchResultsWrapper = activePopup.querySelector('.search-results-wrapper');
                const hasQuery = searchInput.value.trim();
                newSearchInner.classList.toggle('visible', !hasQuery);
                searchResultsWrapper.classList.toggle('visible', hasQuery);
              }
            }, 10);
          }
        }
      }
    };

    const handleSelect = item => () => {
      const newSite = item.dataset.site;
      const currentSite = button.dataset.selectedSite;

      //add class for change color
     // addClass.classList.add(newSite);
      selectedText.textContent = item.textContent;
      button.dataset.selectedSite = newSite;
      addClass.dataset.selectedSite = newSite;


 


      dropdown.classList.remove('active');
      button.classList.remove('active');

      if (newSite !== currentSite) {
        //addClass.classList.remove(newSite);
        popups.classList.remove('visible');
        popups.querySelectorAll('[data-site]').forEach(popup => {
          popup.classList.remove('visible');
        });
      }

      if (isMobile() || (searchInput === document.activeElement && newSite === currentSite)) {
        updatePopupVisibility();
      }
    };

    const handleInputFocus = () => {
      updatePopupVisibility();
    };

    const handleInputBlur = () => {
      setTimeout(() => {
        if (!wrapper.contains(document.activeElement) && !isMobile()) {
          popups.classList.remove('visible');
          popups.querySelectorAll('[data-site]').forEach(popup => {
            popup.classList.remove('visible');
          });
        }
      }, 100);
    };

    const closeOnOutsideClick = e => {
      if (!wrapper.contains(e.target) && !isMobile()) {
        dropdown.classList.remove('active');
        button.classList.remove('active');
        popups.classList.remove('visible');
        popups.querySelectorAll('[data-site]').forEach(popup => {
          popup.classList.remove('visible');
        });
      }
    };

    const handleInput = debounce((e) => {
      if (button.dataset.selectedSite === 'insite') {
        const query = e.target.value.trim();
        fetchSearchResults(query);
      }
    }, 300);

    const handleKeydown = (e) => {
      if (e.key === 'Enter' && button.dataset.selectedSite === 'insite' && searchInput.value.trim()) {
        window.location.href = `/search?q=${encodeURIComponent(searchInput.value.trim())}`;
      }
    };

    setInitialText();
    button.addEventListener('click', toggleDropdown);
    items.forEach(item => item.addEventListener('click', handleSelect(item)));
    searchInput.addEventListener('focus', handleInputFocus);
    searchInput.addEventListener('blur', handleInputBlur);
    searchInput.addEventListener('input', handleInput);
    searchInput.addEventListener('keydown', handleKeydown);
    document.addEventListener('click', closeOnOutsideClick);
    window.addEventListener('resize', updatePopupVisibility);
  };

  Array.from(document.querySelectorAll('.header-search-wrapper')).forEach(initSearch);
});



document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.ed-drawer');
  const drawerOpener = document.querySelectorAll('.mobile-drawer-open');
  const body = document.body;
  const html = document.documentElement;
  
  const toggleDrawer = () => {
    const isOpening = !drawer.classList.contains('open');
    drawer.classList.toggle('open');
    
    body.style.overflow = isOpening ? 'hidden' : 'visible';
    html.style.overflow = isOpening ? 'hidden' : 'visible';
  
    drawerOpener.forEach(opener => {
      if (isOpening) {
        opener.removeAttribute('mobile-drawer-opener');
        opener.setAttribute('mbl-drawer-close', '');
      } else {
        opener.removeAttribute('mbl-drawer-close');
        opener.setAttribute('mobile-drawer-opener', '');
      }
    });
  };
  
  
  drawerOpener.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      toggleDrawer();
    });
  });
  
});





document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll(".menu-item");

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".menu-item-content");
        accordion.classList.add("accordion__active");
        content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".menu-item-content");
        accordion.classList.remove("accordion__active");
        content.style.maxHeight = null;
    };

    accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".menu-item-title");
        const content = accordion.querySelector(".menu-item-content");

        intro.addEventListener('click', () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        });
    });
});
